import React from 'react';
import Icon from '../common/Icon';
import { useNavigate } from 'react-router-dom';

const FieldListItem = ({
  field,
  handleDestroy,
  handleCopy,
  hasValidResponses,
}) => {
  const navigate = useNavigate();
  const { required, type, name, id } = field;

  return (
    <>
      <a className='edit' onClick={() => navigate(`/manage/fields/${id}`)}>
        <div className='cargo'>
          <div className='name'>{name}</div>
          <div className='meta'>{type}</div>
        </div>
      </a>

      <div className={'flag' + (required ? ' required' : '')}>
        <Icon title={required ? 'Required' : 'Optional'} icon='flag' />
      </div>

      <div className='controls'>
        {hasValidResponses === undefined ? (
          <Icon icon='refresh fa-spin' title='Checking responses...' />
        ) : (
          <>
            <Icon
              className='duplicate'
              title='Copy'
              onClick={(e) => handleCopy(e, id)}
              icon='copy'
              faPrefix={'regular'}
            />
            {hasValidResponses === false && (
              <Icon
                className='destroy'
                onClick={(e) => handleDestroy(e, id)}
                icon='trash'
              />
            )}
          </>
        )}
      </div>
    </>
  );
};

export default FieldListItem;
